<section>
    <header class="row page-header margin-bottom-20">
        <div class="col-sm-6 d-flex align-items-center">
          <h2 class="title">PROPERTIES</h2>
        </div>
        <div class="col-sm-6 d-flex align-items-center justify-content-end">            
            <button type="button" class="btn btn-toggle btn-toggle-no-shadow" (click)="exportToExcel()">
                <i class="fa-regular fa-file-excel" aria-hidden="true"></i> 
                Export to Excel
            </button>            
            <button type="button" class="btn btn-toggle btn-toggle-no-shadow" (click)="addProperty.onShow()">
                <i aria-hidden="true" class="fa fa-plus fa-1x"></i>
                Add new property
            </button>
        </div>
    </header>
    <main>
        <sp-add-property #addProperty [workspaceId]="currentWorkspaceId"></sp-add-property>
        <dx-data-grid
            #dxAdminPortfolioPropertiesDataGrid
            id="portfolioPorpertiesDataGrid"
            [dataSource]="dataGridSource"
            [showColumnLines]="false"
            [showRowLines]="true"
            [showBorders]="false"
            (onRowPrepared)="dxGridRowPrepared($event)"        
            (onContentReady)="dxGridOnContentReady()"
            (onContextMenuPreparing)="onContextMenuPreparing($event)"
        >
            <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>

            <dxo-data-grid-search-panel
                [visible]="true"
                alignment="left"
                [highlightSearchText]="false"
                placeholder="Search Properties..."
                width="400"
            ></dxo-data-grid-search-panel>

            <!-- Column Chooser -->
            <dxo-data-grid-column-chooser [enabled]="true" mode="select" height="375">
                <dxo-data-grid-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-data-grid-position>
                <dxo-data-grid-selection [allowSelectAll]="true" [selectByClick]="true"></dxo-data-grid-selection>
            </dxo-data-grid-column-chooser>

            <dxo-data-grid-toolbar>
                <dxi-data-grid-item name="searchPanel" location="before"></dxi-data-grid-item>
                <dxi-data-grid-item location="after">
                    <dx-select-box
                        width="130"
                        [items]="activeFilterItems"
                        [inputAttr]="{ 'aria-label': 'Value' }"
                        displayExpr="text"
                        valueExpr="value"
                        value="active"
                        (onValueChanged)="activeDropdownChanged($event)">
                    </dx-select-box>
                </dxi-data-grid-item>
                <dxi-data-grid-item name="columnChooserButton" location="after"></dxi-data-grid-item>
            </dxo-data-grid-toolbar>
            
            <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" dataField="name" caption="Property Name" width="300" alignment="left" cellTemplate="propertyNameCellTemplate"></dxi-data-grid-column>
            <div *dxTemplate="let cellData of 'propertyNameCellTemplate'">                                
                <a [href]="['#//useraccount/admin/portfolios/' + currentWorkspaceId + '/edit-property/' + cellData.data.propertyId]">                        
                    {{cellData.row.data.name}}                        
                </a>                
            </div>

            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="propertyTypeName" caption="Property Type" alignment="left"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" caption="Location" alignment="left" [calculateCellValue]="dxCalculateCellValueForLocationColumn"></dxi-data-grid-column>             
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="originalCreatedOn" caption="Date Added" dataType="date" alignment="left"></dxi-data-grid-column>        
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="isTest" [calculateCellValue]="dxCalculateCellValueForIsTestColumn" caption="Is Test?" alignment="left"></dxi-data-grid-column>
            
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="isActive" caption="Status" alignment="left" cellTemplate="activeTemplate"></dxi-data-grid-column>            
            <div *dxTemplate="let cellData of 'activeTemplate'">
                <div *ngIf="cellData.row.data.isActive">
                    <span class="status-badge badge-active">Active</span>
                </div>
                <div *ngIf="!cellData.row.data.isActive">
                    <span class="status-badge badge-inactive">Inactive</span>
                </div>
            </div>

            <dxi-data-grid-column cssClass="dx-grid-cell-wrapped" alignment="left" caption="Integration" cellTemplate="integrationTemplate"></dxi-data-grid-column>            
            <div *dxTemplate="let cellData of 'integrationTemplate'">
                <div *ngIf="cellData.row.data.integrationPropertyId != null">
                    <span title="Integration enabled" class="fa fa-plug"></span>
                </div>
            </div>

            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="integrationDetail.integrationVendorName" caption="Vendor Name" alignment="left" [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="integrationDetail.credentialName" caption="Credential Name" alignment="left" [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="integrationDetail.externalPropertyCode" caption="External Code" alignment="left" [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" caption="Last Update Status" alignment="left" [calculateCellValue]="dxCalculateCellValueForIntegrationStatusColumn" [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="integrationDetail.lastUpdateDate" caption="Last Update Date" alignment="left" dataType="date" format="MM/dd/yyyy" [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="integrationDetail.isActive" caption="Is Integration Active?" [calculateCellValue]="dxCalculateCellValueForIntegrationIsActiveColumn" alignment="left" [visible]="false"></dxi-data-grid-column>
            <dxi-data-grid-column cssClass="dx-grid-cell" dataField="integrationDetail.configuredGlCount" caption="Num GL Codes" alignment="left" [visible]="false"></dxi-data-grid-column>

            <dxi-data-grid-column cssClass="dx-grid-cell" alignment="right" cellTemplate="propertyId">
                <div *dxTemplate="let cellData of 'propertyId'">                
                    <dx-button 
                        id="btnShowActionMenu"
                        hint="Action Menu"
                        [hoverStateEnabled]="false"
                        [activeStateEnabled]="false"
                        stylingMode="text" 
                        type="normal" 
                        icon="overflow" 
                        (onClick)="showActionMenu($event)">
                    </dx-button>                  
                </div>
            </dxi-data-grid-column>

            <dxo-data-grid-scrolling rowRenderingMode="virtual"> </dxo-data-grid-scrolling>
            <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>
            <dxo-data-grid-pager
                [visible]="true"
                [allowedPageSizes]="allowedPageSizes"
                [displayMode]="'compact'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true">
            </dxo-data-grid-pager>
        </dx-data-grid>
    </main>
</section>

<sp-modal #deactivatePropertyStatusModal title="DEACTIVATE THIS PROPERTY" (confirm)="deactivateProperty()" confirmButtonText="OK" [isWarning]="true">
    Are you sure you want to deactivate this property?  Users will not be able to access this property anymore.
</sp-modal>

<sp-modal #reactivatePropertyStatusModal title="REACTIVATE THIS PROPERTY" (confirm)="reactivateProperty()" confirmButtonText="OK" [isWarning]="true">
    Are you sure you want to reactivate this property?
</sp-modal>

<sp-admin-reassign-property-modal
    #reassignPropertyModal    
    (onConfirm)="onReassignPropertyConfirm($event)">
</sp-admin-reassign-property-modal>

<sp-modal #duplicatePropertyModal title="DUPLICATE THIS PROPERTY" (confirm)="duplicateProperty()" confirmButtonText="OK" [isWarning]="true">
    <div>
        You are duplicating this property.  To change the information, click on edit after duplication is complete.        
    </div>    
    <div style="font-weight: bold; font-size: larger;">
        This may take several moments to complete!
    </div>    
</sp-modal>

<sp-add-connected-app-modal #addConnectedAppModal
    [propertyId]="connectedAppPropertyId"
    [propertyName]="connectedAppPropertyName"
    [integrationStatus]="connectedAppIntegrationStatus"
></sp-add-connected-app-modal>
